<ppl-accordion [title]="'Invoice Summary'" [isOpen]="true">
  @if(isSectionEditable) {
  <div class="custom-row">
    <div class="mr-2" *ngIf="isImportAllowed">
      <ppl-button label="Import Invoice" icon="fa fa-upload" [customClass]="'primary-button'" [iconPosition]="'left'"
        (click)="openInvoiceImportDialog()"></ppl-button>
    </div>
    <div class="mr-2">
      <ppl-button label="Add Invoice" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
        (click)="openInvoice('add')"></ppl-button>
    </div>
  </div>
  }

  <ppl-accordion [title]="'In Process Invoice'" [isOpen]="true">
    @if(inProgressInvoices.length){
    <ppl-list-table rowDataAccessibilityKey="tas_timesheetheader_detail_id" [disableSort]="false" [disableSearch]="true"
      [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true" [pageConfig]="programName" [sharedDataKey]="sharedDataKey" [actionButtons]="actionButtons"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden" [customDataLoaded]="true" [loadPage]="true"
      (gridAction)="onAction($event, 'inprocess')" [jsonList]="'list_provider_invoice_in_process'"
      (onPageLoad)="onInProcessInvoicePageLoad($event)"
      [data]="inProgressInvoices" [pagination]="true" [recordsPerPage]="10" [from]="'claims'"
      [cellClassResolver]="serviceDatesCellClassResolver">
    </ppl-list-table>
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>


  <ppl-invoice-provider-processed-list [consumers]="consumers" [providerId]="providerId" [provider]="providerData"></ppl-invoice-provider-processed-list>
</ppl-accordion>

<div class="filter-panel">
  <ng-template #addInvoiceDialog let-cancel="cancel">
    <ppl-add-invoice [providerId]="providerId" [consumers]="consumers" [mode]="mode" [provider]="providerData" [invoiceId]="invoiceId" [consumerId]="selectedRow?.consumerId"
      [providerView]="true" (invoiceSaved)="handleCancel($event)" (cancel)="handleCancel($event)" [isReadOnly]="isReadOnly || !isSectionEditable" [canApproveReject]="canApproveReject"></ppl-add-invoice>
  </ng-template>
</div>

<ppl-popup-dialog [(isVisible)]="shoInvoiceImportDialog" [title]="'Import Invoice'" [showClose]="true"
  [showButtons]="false" size="medium" position="center">
  <div class="import-invoice-dialog">
    <div class="dialog-section">
      <p class="dialog-text">Download the Excel template and fill in invoice details.</p>

      <ppl-button buttonType="secondary" [icon]="'pi pi-download'" [label]="'Download Template'"
        (handleClick)="downloadInvoiceTemplate()">
      </ppl-button>
    </div>

    <div class="dialog-section">
      <p class="dialog-text strong">Upload File</p>

      <label class="file-upload">
        <input #fileInput type="file" accept=".xlsx" hidden (click)="resetFileInput(fileInput)"
          (change)="onInvoiceFileSelected($event)" />

        <ppl-button buttonType="secondary" [label]="'Choose File'" (handleClick)="fileInput.click()">
        </ppl-button>
      </label>
      @if(selectedInvoiceFile) {
      <p class="dialog-selected">
        Selected file: <strong>{{ selectedInvoiceFile.name }}</strong>
      </p>
      }


      <p class="dialog-hint">Supported formats: <strong>.xlsx</strong></p>
    </div>

    <div class="dialog-footer">
      <ppl-button buttonType="primary" [label]="'Import'" [disabled]="!selectedInvoiceFile"
        (handleClick)="importInvoiceFile()">
      </ppl-button>
    </div>
  </div>
</ppl-popup-dialog>